import React from 'react';
import { useTranslation } from 'react-i18next';

import CustomDatePickers from './CustomDatePickers';

interface CustomDateRangeProperties {
  inputLabel?: string;
  value1: string;
  value2: string;
  name1: string;
  name2: string;
  onChangeValue: (name: string, value: string) => void;
  valueRequired?: boolean;
  readOnly?: boolean;
  error?: boolean;
  errorMessage?: string;
  disablePastDates?: boolean;
  minDate?: string;
}

/**
 * Custom Date Range function component
 */
function CustomDateRanges({
  inputLabel,
  name1,
  name2,
  value1,
  value2,
  onChangeValue,
  valueRequired,
  readOnly,
  error,
  errorMessage,
  disablePastDates,
  minDate,
}: CustomDateRangeProperties) {
  /**
   * Date Range field handle function
   */
  const handleValueChange = (name: string, changeValue: string) => onChangeValue(name, changeValue);
  const { t } = useTranslation('sharedComp');
  return (
    <div className="custom-input-date-wrap">
      {inputLabel && (
        <p className="input-label">
          {inputLabel}
          {valueRequired && <span>*</span>}
        </p>
      )}
      <div className="custom-date-input">
        <CustomDatePickers
          name={name1}
          placeholder={t('from')}
          value={value1}
          readOnly={readOnly}
          onChangeValue={handleValueChange}
          disablePastDates={disablePastDates}
          minDate={minDate}
        />
        <CustomDatePickers
          name={name2}
          placeholder={t('to')}
          value={value2}
          readOnly={readOnly}
          onChangeValue={handleValueChange}
          disablePastDates={disablePastDates}
          minDate={value1 || minDate}
        />
      </div>
      {error && <p className="custom-input-error-message">{errorMessage}</p>}
    </div>
  );
}

CustomDateRanges.defaultProps = {
  inputLabel: '',
  valueRequired: false,
  readOnly: false,
  error: false,
  errorMessage: '',
  disablePastDates: false,
  minDate: '',
};

export default CustomDateRanges;
